<ng-container *transloco="let t">
  <div class="flex h-full flex-col gap-4">
    <div class="flex-1">
      <div class="form-group row mb-4">
        <label class="col-sm-2 mb-0 py-2">{{ t("strategy-group-move-product-modal.move_to") }}</label>
        <div class="col-sm-10">
          <ISelectMenu
            [value]="productStrategy()"
            (valueChange)="setProductStrategy($event)"
            [(searchQuery)]="searchQuery"
            fitTriggerWidth
          >
            <ISelectTrigger class="flex w-full">
              <ISelectValue>
                <div *iSelectValue="let value">
                  @if (value === "NewProductStrategy") {
                    {{ t("strategy-group-move-product-modal.a_new_main_strategy") }}
                  } @else if (value === "NewStrategy") {
                    {{ t("strategy-group-move-product-modal.a_new_strategy") }}
                  } @else {
                    {{ value.name }}
                  }
                </div>
              </ISelectValue>
            </ISelectTrigger>
            <ISelectContent>
              <ISelectOption value="NewProductStrategy">
                {{ t("strategy-group-move-product-modal.a_new_main_strategy") }}
              </ISelectOption>
              <ISelectOption value="NewStrategy">
                {{ t("strategy-group-move-product-modal.a_new_strategy") }}
              </ISelectOption>
              @for (strategy of filteredExistingStrategies(); track strategy.strategyId) {
                <ISelectOption [value]="strategy">
                  {{ strategy.name }}
                </ISelectOption>
              }
            </ISelectContent>
          </ISelectMenu>
        </div>
      </div>
      <div class="flex flex-col">
        @if (productStrategy() === "NewProductStrategy" || productStrategy() === "NewStrategy") {
          <IFormField>
            <label iLabel>{{ t("sp-strategy-creation.strategy_name") }}</label>
            <input
              iInput
              class="w-full"
              [placeholder]="
                t(
                  productStrategy() === 'NewProductStrategy'
                    ? 'strategy-group-add-product-modal.please_enter_a_name_for_your_main_strategy'
                    : 'sp-strategy-creation.please_enter_a_name_for_your_strategy'
                )
              "
              [(ngModel)]="productStrategyName"
              [maxLength]="80"
            />
          </IFormField>
          <app-algo-mode-selection
            (algoModeConfig)="setAlgoModeConfig($event)"
            [currencyCode]="currencyCode()"
            class="mt-4 w-full"
          />
        }
      </div>
    </div>
    <div class="flex justify-end gap-2 py-2">
      <button iButton variant="secondary" size="md" (click)="close()">{{ t("common.cancel") }}</button>
      <button
        iButton
        size="md"
        type="submit"
        [disabled]="invalid()"
        [loading]="loading()"
        [iTooltip]="invalidTooltip()"
        (click)="save()"
      >
        {{ t("common.save") }}
      </button>
    </div>
  </div>
</ng-container>
